module.exports = __webpack_public_path__ + "img/dankort.4d9ac6a.png";